module.exports = __webpack_public_path__ + "assets/img/bjimg3.14d7499f.png";